<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h1 class="h2"><i class="fa-solid fa-building me-2"></i>Abteilungen ({{totalEntries}})</h1>
</div>

<button type="button" class="btn btn-primary mb-3" [routerLink]="['/department', 0]">Abteilung anlegen</button>

<div class="table-responsive">
    <table *ngIf="entries?.length > 0" class="table table-sm table-striped table-hover bg-white pointer">
        <thead>
        <tr>
            <th (click)="setOrder('name')">
                Name <i class="fas" *ngIf="predicate == 'name'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('users')">
                # Benutzer <i class="fas" *ngIf="predicate == 'users'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
            <th (click)="setOrder('tasks')">
                # Aufgaben <i class="fas" *ngIf="predicate == 'tasks'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
            </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let entry of entries" [routerLink]="['/department', entry.id]">
            <td>{{ entry.name }}</td>
            <td>
                <i class="fa fa-exclamation-triangle text-warning" *ngIf="entry.users == 0"></i>
                {{ entry.users }}
            </td>
            <td>{{ entry.tasks }}</td>
        </tr>
        </tbody>
    </table>
</div>
